const enum LocaleIsoEnum {
    Swedish = 'sv_SE',
    SwedishFinland = 'sv_FI',
    Finnish = 'fi_FI',
    Norwegian = 'nb_NO',
    Danish = 'da_DK',
}

export default LocaleIsoEnum;
